<div class="poll-title">
    {{data.title}}
</div> 
<div class="pie-chart">
  <div class="col-6">
    <ngx-charts-pie-chart *ngIf="data"
    [scheme]="colorScheme"
    [results]="data.answers"
    [legendPosition]="legendPosition"
    [doughnut]="isDoughnut"
    [activeEntries]="activeEntries"
    >
    </ngx-charts-pie-chart>
  </div>
  <div class="col-6">
    <ngx-charts-legend fxFlex="100%" class="chart-custom"
    [data]="chartNames"
    [colors]="colors"
    (labelActivate)="legendLabelActivate($event)"
    (labelDeactivate)="legendLabelDeactivate($event)">
    </ngx-charts-legend>
  </div>
</div>